export default "__VITE_ASSET__BIRFDQFG__"